import { useFindAllContactSentimentsQuery } from 'services';
import { FindAllContactSentimentsDto } from 'types';

export const useFindAllContactSentiments = (data?: FindAllContactSentimentsDto, options?: any) => {
  const {
    data: contactSentiments,
    isLoading: isLoadingContactSentiments,
    isFetching: isFetchingContactSentiments,
    refetch: refetchContactSentiments
  } = useFindAllContactSentimentsQuery(data!, {
    refetchOnMountOrArgChange: true,
    skip: !data?.filters || data.filters.length === 0,
    ...options
  });

  return {
    contactSentiments: contactSentiments?.data?.rows,
    isLoadingContactSentiments,
    isFetchingContactSentiments,
    refetchContactSentiments
  };
};
